module.exports = __webpack_public_path__ + "img/icon_b.811c91c2.png";